// import { useStore } from "effector-react"
import React, { useEffect } from "react"
import { NavLink } from "react-router-dom"

import "../styles/DemandSidebar.css";
import { urlDemandSubGroupServices } from "../../../common/config/vars";
import { $accounts, $selectedAccountIdx } from "../../../common/accounts2";
import { $contractorDems, queryContractorDems} from "../logics/contractorDemands";
import { useStore } from "effector-react";

interface ISidebarGroupList {
  setCurrItem: React.Dispatch<React.SetStateAction<string>>
}

export const SidebarGroupList = ({setCurrItem}: ISidebarGroupList) => {
  const selAccIdx = useStore($selectedAccountIdx)
  const {accounts} = useStore($accounts)


  const [openMenu, setOpenMenu] = React.useState(false);
  const buttonClassName = `${
    openMenu
      ? "dem-sidebar-button dem-sidebar-button_active"
      : "dem-sidebar-button"
  }`;
  function openCloseMenu() {
    setOpenMenu(!openMenu);
  }
  function closeByRedirect(itemText: string) {
    setOpenMenu(false);
    setCurrItem(`Категория "${itemText}"`)
  }
  const sidebarClassName = `${
    openMenu ? "dem-sidebar dem-sidebar-active" : "dem-sidebar"
  }`;

  const {loading, failMsg, groups, services} = useStore($contractorDems)
  // companyId выбранного ЛС; грузим категории, только когда он известен (иначе на старте уходил -1)
  const selCompanyId = (selAccIdx > -1 && selAccIdx < accounts.length) ? accounts[selAccIdx]?.companyId : undefined
  useEffect(() => {
    if (selCompanyId !== undefined) queryContractorDems(selCompanyId.toString())
  }, [selCompanyId])

  return (
    <>
      <ul style={{width: "100%"}}>
        <li>
          <div className="category">Категории</div>
          <ul>
            {loading ? "Загрузка данных": <></>}
            {failMsg !=  "" ? failMsg: <></>}
            {groups.map((g, i) => (
              <li key={i}>
                <NavLink exact to={urlDemandSubGroupServices+ "/" + g.id} className="category-item" onClick={() => closeByRedirect(g.name)}>{g.name}</NavLink>
            </li>
            ))}
          </ul>
        </li>
      </ul>
    </>
  )
}